var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card events-card full-height"},[_c('div',{staticClass:"card-content"},[_vm._v("EstablishmentDetail")])])}]

export { render, staticRenderFns }